import { createReducer } from "@reduxjs/toolkit";
import { certificazioneContattoClienteAction, getDettaglioCertificazioneClienteAction, inviaSmsCertificazioneClienteAction, loginUserAction, resetAccessTokenClienteAction, setAccessTokenClienteAction } from "./actions";
import { ClienteReducerType } from "./types";

const initialState: ClienteReducerType = {
  tokenLoginUser: undefined,
  dettaglioCertificazioneCliente: undefined,
  dettaglioSmsCertificazioneCliente: undefined,
  certificazioneContattoCliente: undefined
};

export const clienteReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(setAccessTokenClienteAction, (state, action) => {
      state.tokenLoginUser = action.payload;
    })
    .addCase(resetAccessTokenClienteAction, (state) => {
      state.tokenLoginUser = initialState.tokenLoginUser;
    })
    .addCase(loginUserAction.pending, (state) => {
      state.tokenLoginUser = initialState.tokenLoginUser;
    })
    .addCase(loginUserAction.fulfilled, (state, action) => {
      state.tokenLoginUser = action.payload?.accessToken || undefined;
    })
    .addCase(loginUserAction.rejected, (state, action) => {
      console.log('errore login cliente', action);
    })
    .addCase(getDettaglioCertificazioneClienteAction.pending, (state) => {
      state.dettaglioCertificazioneCliente = initialState.dettaglioCertificazioneCliente;
    })
    .addCase(getDettaglioCertificazioneClienteAction.fulfilled, (state, action) => {
      state.dettaglioCertificazioneCliente = action.payload;
    })

    .addCase(inviaSmsCertificazioneClienteAction.pending, (state) => {
      state.dettaglioSmsCertificazioneCliente = initialState.dettaglioSmsCertificazioneCliente;
    })
    .addCase(inviaSmsCertificazioneClienteAction.fulfilled, (state, action) => {
      state.dettaglioSmsCertificazioneCliente = action.payload;
    })
    .addCase(certificazioneContattoClienteAction.pending, (state) => {
      state.certificazioneContattoCliente = initialState.certificazioneContattoCliente;
    })
    .addCase(certificazioneContattoClienteAction.fulfilled, (state, action) => {
      state.certificazioneContattoCliente = action.payload;
    })

});
